import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function ProofSection() {
  return <section className="px-6 py-10" data-id="element-135">
      <div className="max-w-4xl mx-auto" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative bg-brand-accent/10 border border-brand-accent/20 rounded-3xl p-8 md:p-12 text-center" data-id="element-137">
          <Quote className="w-12 h-12 text-brand-accent/40 mx-auto mb-6" data-id="element-138" />
          <p className="font-serif text-xl md:text-3xl text-brand-light leading-relaxed italic" data-id="element-139">
            "En solo 7 días, las parejas que aplican este protocolo reportan una
            reducción del 40% en las discusiones logísticas y un aumento
            significativo en el contacto físico espontáneo, simplemente al
            eliminar la presión del 'desempeño' y enfocarse en la regulación
            emocional mutua."
          </p>
        </motion.div>
      </div>
    </section>;
}